var toPath = {};
export {
  toPath as __exports
};
//# sourceMappingURL=toPath.js.map
